module.exports = __webpack_public_path__ + "img/partner.eef11b5.webp";